import { useEffect, useRef } from "react";

export const useVimBindings = (scrollRef, onSearch, onCommandPalette) => {
    const keySequence = useRef("");
    const sequenceTimer = useRef(null);

    useEffect(() => {
        const handleKeyDown = (e) => {
            // Don't intercept if user is typing in an input
            if (
                e.target.tagName === "INPUT" ||
                e.target.tagName === "TEXTAREA"
            ) {
                return;
            }

            const key = e.key;

            // Clear sequence timer and start new one
            if (sequenceTimer.current) {
                clearTimeout(sequenceTimer.current);
            }

            sequenceTimer.current = setTimeout(() => {
                keySequence.current = "";
            }, 1000);

            // Add key to sequence
            keySequence.current += key;

            // Check for gg (go to top)
            if (keySequence.current.endsWith("gg")) {
                e.preventDefault();
                if (scrollRef.current) {
                    scrollRef.current.scrollTo({ top: 0, behavior: "smooth" });
                }
                keySequence.current = "";
                return;
            }

            // Single key commands
            switch (key) {
                case "j":
                    // Scroll down
                    e.preventDefault();
                    if (scrollRef.current) {
                        scrollRef.current.scrollBy({
                            top: 40,
                            behavior: "smooth",
                        });
                    }
                    break;

                case "k":
                    // Scroll up
                    e.preventDefault();
                    if (scrollRef.current) {
                        scrollRef.current.scrollBy({
                            top: -40,
                            behavior: "smooth",
                        });
                    }
                    break;

                case "G":
                    // Go to bottom
                    e.preventDefault();
                    if (scrollRef.current) {
                        scrollRef.current.scrollTo({
                            top: scrollRef.current.scrollHeight,
                            behavior: "smooth",
                        });
                    }
                    keySequence.current = "";
                    break;

                case "/":
                    // Activate search
                    e.preventDefault();
                    if (onSearch) {
                        onSearch();
                    }
                    keySequence.current = "";
                    break;

                case ":":
                    // Open command palette
                    e.preventDefault();
                    if (onCommandPalette) {
                        onCommandPalette();
                    }
                    keySequence.current = "";
                    break;

                default:
                    break;
            }
        };

        window.addEventListener("keydown", handleKeyDown);
        return () => {
            window.removeEventListener("keydown", handleKeyDown);
            if (sequenceTimer.current) {
                clearTimeout(sequenceTimer.current);
            }
        };
    }, [scrollRef, onSearch, onCommandPalette]);
};
